import type { ItemEdit } from "../../../api/content/changeSetsApi";

/**
 * The prompt of an agent step being written (AU-4): an existing prompt version, or a new
 * prompt saved with the step in the same change set. A new prompt gets its item ID in the
 * browser, so the step's commit can pin the version the prompt's commit wrote.
 */
export type PromptDraft =
  | { readonly kind: "existing"; /** `""` while none is chosen. */ readonly reference: string }
  | { readonly kind: "new"; readonly itemId: string; readonly name: string; readonly description: string; readonly text: string };

/** The prompt of a step that is not an agent step, or of a new agent step: none chosen. */
export const NO_PROMPT: PromptDraft = { kind: "existing", reference: "" };

export function promptDraftOf(reference: string): PromptDraft {
  return { kind: "existing", reference };
}

/** The edit that creates a new prompt; `null` for an existing one or none. */
export function newPromptEdit(prompt: PromptDraft | null, fallbackName: string): (ItemEdit & { readonly operation: "create"; readonly item_id: string }) | null {
  if (prompt?.kind !== "new") {
    return null;
  }
  const name = prompt.name.trim() === "" ? fallbackName : prompt.name.trim();
  return { operation: "create", item_id: prompt.itemId, content: { kind: "prompt", name, ...(prompt.description === "" ? {} : { description: prompt.description }), text: prompt.text } };
}
